// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"669":"d2b2c1b2","787":"d6f5e4cf"}[chunkId] + ".chunk.js";
};